import _ from 'lodash'
import {Notisphere_Recall_Review_AgGrid, AG_GridCustomizedTableHeaders_Key} from '../../../misc/tableHeaders.js'
import recallReviewServices from '../../../services/notisphere/recallReview.js'
import RecallReviewModal from './RecallReviewModal'

export default {
    components: {
        RecallReviewModal
    },
    data() {
        return {
            columnDefs: null,
            total: 0,
            items: [],
            gridApi: null,
            columnApi: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                serverSideSortAllLevels: true,
                suppressServerSideInfiniteScroll: true
            },
            searchQuery: { pageNumber: 1, pageSize: 20, sort: null, colId: null },
            globalSearchText: '',
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            recallReviewModalKey: 0,
            currentRowIndex: null,
            allRowsData: [],
        }
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    beforeMount() {
        this.columnDefs = Notisphere_Recall_Review_AgGrid
    },
    mounted() {
        if(this.$route?.params?.id){
            // Wait a bit for grid to load data, then find the index and show modal
            const checkDataAndShow = () => {
                if (this.allRowsData.length > 0) {
                    const index = this.allRowsData.findIndex(item => item.review_id === this.$route.params.id)
                    this.currentRowIndex = index >= 0 ? index : 0
                    this.recallReviewModalKey += 1
                    this.$nextTick(() => {
                        this.$refs.recallReviewModal.show(this.$route.params.id, this.currentRowIndex, this.allRowsData.length)
                    })
                } else {
                    // If data not loaded yet, try again after a short delay
                    setTimeout(checkDataAndShow, 100)
                }
            }
            checkDataAndShow()
        }
    },
    methods: {
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email


                    const statusFilter = params.api.getFilterModel()?.status?.filter
                    let mappedStatusFilter = null
                    if (statusFilter) {
                        mappedStatusFilter = statusFilter
                    }

                    const query_param = {
                        ...searchquery,
                        search: that.globalSearchText,
                        email: email,
                        filterModel: params.api.getFilterModel(),
                    }
                    const resp = await recallReviewServices.downloadAgGridRecallReviewXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },

        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Recall_Review_Header = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },

        setFilterModel(params) {
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            const filterModel = tableState?.Notisphere_Login?.RecallReview_Filters || {}
            params.api.setFilterModel(filterModel)
        },

        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.Recall_Review_Header
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },

        fetchData(params) {
            let that = this
            this.applyState(params)
            this.setFilterModel(params)
            that.gridApi = params.api
            that.columnApi = params.columnApi
            localStorage.setItem(
                'agGridColumState',
                JSON.stringify(params.columnApi.getColumnState())
            )
            localStorage.setItem(
                'agGridFilterModel',
                JSON.stringify(params.api.getFilterModel())
            )
            const filterModel = that.gridApi.getFilterModel()
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort

            const datasource = {
                getRows(params) {

                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.searchQuery.filterModel = that.gridApi.getFilterModel()

                    recallReviewServices.getRecallReviews({
                        ...that.searchQuery,
                        search: that.globalSearchText,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel
                    })
                        .then(resp => {

                            if (!resp.error && resp.data?.d?.data) {
                                that.total = resp.data.d?.totalCount || 0
                                const responseObject = (resp.data.d.data || []).map((respItem) => {
                                    try {
                                        const obj = {
                                            review_id: respItem._id,
                                            recall_name: respItem.recall_info?.recall_name,
                                            recall_id: respItem.recall_info?.recall_id,
                                            recall_date: respItem.recall_info?.recall_date,
                                            recall_type: respItem.recall_info?.recall_type,
                                            filename: respItem.documents.length > 0 ? respItem.documents?.map(doc => doc.filename).join(', ') : '',
                                            documents: respItem.documents,
                                            recalling_firm: respItem.recall_info?.recalling_firm,
                                            product_name: respItem.recall_info?.product_list.length > 0 ? respItem.recall_info?.product_list?.map(prod => prod.name).join(', ') : '',
                                            product_list: respItem.recall_info?.product_list,
                                            status: respItem.status,
                                            originality: respItem.originality,
                                            recall_action_type: respItem.recall_info?.isVoluntary,
                                            description: respItem.recall_info?.description,
                                            health_risk: respItem.recall_info?.health_risk,
                                            provider_name: respItem.metadata?.provider_name,
                                            provider_creation_date: respItem.metadata?.provider_creation_date,
                                            created_at: respItem.created_at,
                                            updated_at: respItem.updated_at,
                                            actions: respItem.recall_info?.actions && respItem.recall_info?.actions.length > 0 ? respItem.recall_info?.actions?.map(action => action.value).join(', ') : '',
                                            action_details: respItem.recall_info?.actions,
                                            instructions: respItem.recall_info?.instructions,
                                            metadata: respItem.metadata,
                                            original_id: respItem.original_id,
                                            duplicates: respItem.duplicates,
                                            recall_category: respItem.recall_info?.recall_category,
                                            response_email: respItem.recall_info?.response_email,
                                            response_form: respItem.recall_info?.response_form,
                                            urgent: respItem.recall_info?.urgent,
                                            correction: respItem.correction
                                        }
                                        return obj
                                    } catch (e) {
                                        console.error('Error mapping recall item:', respItem, e)
                                        return null
                                    }
                                }).filter(item => item !== null)

                                const lastRow = that.total
                                that.allRowsData = [...responseObject]
                                params.successCallback(responseObject, lastRow)
                            } else {
                                console.error('Invalid API response:', resp)
                                params.failCallback()
                            }
                        })
                        .catch(error => {
                            console.error('Error fetching recalls reviews:', error)
                            params.failCallback()
                        })
                }
            }

            params.api.setServerSideDatasource(datasource)
        },
        onCellClicked(params) {
            // Find the actual index in allRowsData
            const index = this.allRowsData.findIndex(item => item.review_id === params.data?.review_id)
            this.currentRowIndex = index >= 0 ? index : params.rowIndex
            this.recallReviewModalKey += 1
            this.$nextTick(() => {
                this.$refs.recallReviewModal.show(params.data?.review_id, this.currentRowIndex, this.allRowsData.length)
            })
        },
        goToNextRecord() {
            if (this.currentRowIndex !== null && this.currentRowIndex < this.allRowsData.length - 1) {
                this.currentRowIndex += 1
                const nextData = this.allRowsData[this.currentRowIndex]
                this.$refs.recallReviewModal.show(nextData?.review_id, this.currentRowIndex, this.allRowsData.length)
            }
        },
        goToPreviousRecord() {
            if (this.currentRowIndex !== null && this.currentRowIndex > 0) {
                this.currentRowIndex -= 1
                const prevData = this.allRowsData[this.currentRowIndex]
                this.$refs.recallReviewModal.show(prevData?.review_id, this.currentRowIndex, this.allRowsData.length)
            }
        },
        onFilterChanged(event) {
            const filterModel = event.api.getFilterModel()
            this.table_Connection_Data.Notisphere_Login.RecallReview_Filters = filterModel
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.saveState(event)
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length >= 1) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
        async downloadChangeLogReport(){
            const resp = await recallReviewServices.downloadChangeLogReport(this.$store.state.user.email)
            if (!resp.error) {
                this._showOk(resp.data.d.message, {
                    variant: 'success',
                    title: 'Message',
                    buttonTitle: 'Ok',
                })
            }
        }
    }
}